import { Tile } from "@carbon/react";
import React from "react";
import styled from "styled-components";
const Description = styled.p `
	font-size: 15px !important;
`;
export const AppTeaserCard = (props) => {
    const gap = 1;
    return (React.createElement(Tile, { style: {
            gridColumn: props.grid?.column ?? 1,
            padding: "16px",
            height: "100%",
        } },
        React.createElement("div", { style: {
                display: "grid",
                gap: `${gap}rem`,
                gridTemplateRows: `auto auto 1fr`,
                height: "100%",
            } },
            React.createElement("h2", null, props.title),
            React.createElement(Description, null, props.description),
            React.createElement("img", { src: props.img.path, alt: props.img.altText, style: { alignSelf: "end", width: "100%" } }))));
};
